// FILE: src/components/Footer.js
// DESKRIPSI: Diperbarui dengan teks di samping logo dan link eksternal.

import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  // Data untuk ikon sosial media dan marketplace
  const socialMedia = [
    { name: 'Facebook', icon: '/images/facebook.png', url: '#' },
    { name: 'Instagram', icon: '/images/instagram.png', url: '#' },
    { name: 'YouTube', icon: '/images/youtube.png', url: '#' },
    { name: 'TikTok', icon: '/images/tiktok.png', url: '#' },
  ];

  const marketplace = [
    { name: 'Tokopedia', icon: '/images/tokopedia.png', url: '#' },
    { name: 'Shopee', icon: '/images/shopee.png', url: '#' },
    { name: 'TikTok Shop', icon: '/images/tiktok-shop.png', url: '#' },
    { name: 'Bukalapak', icon: '/images/bukalapak.png', url: '#' },
    { name: 'Blibli', icon: '/images/blibli.png', url: '#' },
    { name: 'Lazada', icon: '/images/lazada.png', url: '#' },
  ];

  return (
    <footer className="bg-amber-500 text-white">
      <div className="max-w-screen-xl mx-auto py-12 px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* Kolom 1: Info Perusahaan */}
          <div className="space-y-4">
            {/* PERUBAHAN: Logo dan teks sekarang menjadi link eksternal */}
            <a 
              href="https://nurhidayahpress.id" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center space-x-4 hover:opacity-80 transition-opacity mb-4"
            >
              <img src="/images/logo.png" alt="Logo NH Press" className="h-16 w-auto" />
              <span className="font-bold text-2xl">Nur Hidayah Press</span>
            </a>
            <div>
              <h3 className="font-bold text-lg">Alamat</h3>
              <p className="opacity-90">Jl. Kalingga VIII No. 2B, Kadipiro, Banjarsari, Kota Surakarta, Jawa Tengah, 57136</p>
            </div>
            <div>
              <h3 className="font-bold text-lg">No. Telepon/WhatsApp</h3>
              <p className="opacity-90">0858-6913-1499</p>
            </div>
            <div>
              <h3 className="font-bold text-lg">Email</h3>
              <p className="opacity-90">penerbitnhpress@gmail.com</p>
            </div>
          </div>

          {/* Kolom 2: Perusahaan */}
          <div className="space-y-4">
            <h3 className="font-bold text-xl">Perusahaan</h3>
            <ul className="space-y-2">
              <li><Link to="/kontak" className="opacity-90 hover:opacity-100">Kontak</Link></li>
              <li><Link to="/karir" className="opacity-90 hover:opacity-100">Karir</Link></li>
              <li><Link to="/faq" className="opacity-90 hover:opacity-100">FAQ</Link></li>
            </ul>
          </div>

          {/* Kolom 3: Sosial Media & Marketplace */}
          <div className="space-y-8">
            <div>
              <h3 className="font-bold text-xl mb-4">Sosial Media</h3>
              <div className="flex flex-wrap gap-3">
                {socialMedia.map((social) => (
                  <a key={social.name} href={social.url} target="_blank" rel="noopener noreferrer" className="bg-white/20 p-2 rounded-full hover:bg-white/30 transition-colors">
                    <img src={social.icon} alt={social.name} className="h-6 w-6" />
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h3 className="font-bold text-xl mb-4">Marketplace</h3>
              <div className="flex flex-wrap gap-3">
                {marketplace.map((market) => (
                  <a key={market.name} href={market.url} target="_blank" rel="noopener noreferrer" className="bg-white/20 p-2 rounded-full hover:bg-white/30 transition-colors">
                    <img src={market.icon} alt={market.name} className="h-6 w-6" />
                  </a>
                ))}
              </div>
            </div>
          </div>

        </div>
        <div className="mt-12 border-t border-white/20 pt-8 text-center">
          <p className="opacity-90">&copy; {new Date().getFullYear()} NH Press. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
